import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query'
import { transferUserAsset } from './user-transfer.service'
import type {
  UserCheckBuyoutEligibilityParams,
  UserListUserAssetTransfersParams,
  UserUserAssetTransferInput,
} from '../api'
import { EUserTransferQueryKey } from './user-transfer.types'
import type { IMutationArgs } from '../types'
import {
  getCheckBuyoutEligibilityOptions,
  getListUserAssetTransfersInfiniteOptions,
} from './user-transfer.options'

export const useTransferUserAsset = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args
  return useMutation({
    mutationFn: (data: UserUserAssetTransferInput) => transferUserAsset(data),
    mutationKey: [EUserTransferQueryKey.TRANSFER_USER_ASSET],
    onSuccess: (data) => {
      if (invalidate) {
        queryClient.invalidateQueries({
          queryKey: [EUserTransferQueryKey.TRANSFER_USER_ASSET],
        })
      }
      return data
    },
    onError: (error) => {
      return error
    },
  })
}

export const useCheckBuyoutEligibility = (
  params: UserCheckBuyoutEligibilityParams,
) => {
  return useQuery(getCheckBuyoutEligibilityOptions(params))
}
export const useListUserAssetTransfers = (
  params: UserListUserAssetTransfersParams,
) => useInfiniteQuery(getListUserAssetTransfersInfiniteOptions(params))
